import { getFeedsType } from '@/app/services/rooms/rooms';
import * as Actions from '@/app/store/actions';
import {
	Avatar,
	CircularProgress,
	IconButton,
	Paper,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
} from '@material-ui/core';
import moment from 'moment';
import { useEffect, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router';
import './roomspage.css';
import { useNavigate, useLocation } from 'react-router-dom';

const FeedsTypeDetail = () => {
	const dispatch = useDispatch();
	const [rows, setRows] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const [hasMore, setHasMore] = useState(false);
	const [firstLoad, setFirstLoad] = useState(true);
	const [fetchingMore, setFetchingMore] = useState(false);
	const [page, setPage] = useState(1);
	const { id } = useParams();
	const location = useLocation();
	const { room } = location.state;
	const navigate = useNavigate();

	useEffect(() => {
		let isMounted = true;
		if (!room) {
			navigate(-1);
			return;
		}
		const timeout = setTimeout(
			() => {
				if (!isMounted) return;
				setIsLoading(true);
				const payload = {
					id,
					page,
					room_id: room.id,
				};
				getFeedsType(payload)
					.then((res) => {
						if (!isMounted) return;
						setFirstLoad(false);
						setRows(res.data.data);
						setHasMore(res.data.to < res.data.total);
						setPage(page + 1);
					})
					.catch(() => {
						if (!isMounted) return;
						dispatch(
							Actions.showMessage({
								message: 'Failed to fetch data, please refresh',
								variant: 'error',
							})
						);
					})
					.finally(() => {
						if (!isMounted) return;
						setIsLoading(false);
					});
			},
			firstLoad ? 0 : 1000
		);
		return () => {
			isMounted = false;
			clearTimeout(timeout);
		};
	}, []);

	const handleLoadMore = () => {
		setFetchingMore(true);
		const payload = {
			id,
			page,
			room_id: room.id,
		};
		getFeedsType(payload)
			.then((res) => {
				setFirstLoad(false);
				setRows(rows.concat(res.data.data));
				setHasMore(res.data.current_page < res.data.last_page);
				setFetchingMore(false);
				setPage(page + 1);
			})
			.catch(() => {
				setFetchingMore(false);
				dispatch(
					Actions.showMessage({
						message: 'Failed to fetch data, please refresh',
						variant: 'error',
					})
				);
			});
	};

	return (
		<div className="mx-auto room-width">
			<div className="flex items-center flex-nowrap justify-between">
				<span className="personal-hd info-hd stext-pd-2xl self-end  " style={{ fontWeight: '700' }}>
					<h1 className="hd-main">
						{' '}
						<span className="mr-12 icon-color">
							<IconButton
								className="pl-0"
								onClick={() => {
									navigate(`/rooms-room/${room.id}`, { state: { row: room, feeds: true } });
								}}
							>
								<img alt="filter" className="fiterimg" src="assets/images/arrow-long.png" width="24px" />
							</IconButton>
						</span>{' '}
						{room?.name}: Feeds
					</h1>
				</span>
			</div>
			<TableContainer className="room-table-cont" component={Paper} id="Scrollable-table">
				<Table className="rooms-table" stickyHeader style={{ width: '100%' }}>
					<TableHead>
						<TableRow>
							<TableCell className="bg-white roomsTableHeader" style={{ width: '30%' }}>
								Activity Type
							</TableCell>
							<TableCell className="bg-white roomsTableHeader" style={{ width: '30%' }}>
								Students
							</TableCell>
							<TableCell className="bg-white roomsTableHeader" style={{ width: '30%' }}>
								Time
							</TableCell>
							<TableCell className="bg-white roomsTableHeader" style={{ width: '30%' }}>
								Date
							</TableCell>
						</TableRow>
					</TableHead>

					<TableBody className="">
						{isLoading ? (
							<TableRow>
								<TableCell align="center" colSpan={8}>
									<CircularProgress size={35} />
								</TableCell>
							</TableRow>
						) : !rows.length && !firstLoad ? (
							<TableRow>
								<TableCell align="center" colSpan={8}>
									No Feeds to show
								</TableCell>
							</TableRow>
						) : (
							rows?.map((row) => (
								<TableRow key={row.id}>
									<TableCell component="th" scope="row">
										<div className="flex items-center">
											<Avatar className="mr-16" src={row.activity.photo} />
											<div className="rooms-school-name">{row.activity.name}</div>
										</div>
									</TableCell>

									<TableCell>
										<div className="flex items-center">
											<Avatar className="mr-16" src={row?.student?.photo} />
											<div className="flex flex-col items-start">
												<div className="student-name truncate break-word">
													{row.student?.first_name} {row.student?.last_name}
												</div>
												<div className="font-normal truncate student-age-font">{row.student?.age}</div>
											</div>
										</div>
									</TableCell>
									<TableCell>{moment(row?.created_at).format('LT')}</TableCell>
									<TableCell>{moment(row?.created_at).format('l')}</TableCell>
								</TableRow>
							))
						)}
						{fetchingMore ? (
							<TableRow>
								<TableCell align="center" colSpan={8}>
									<CircularProgress size={35} />
								</TableCell>
							</TableRow>
						) : null}
					</TableBody>
				</Table>
			</TableContainer>
			<InfiniteScroll
				dataLength={rows.length}
				hasMore={hasMore}
				next={handleLoadMore}
				scrollableTarget="Scrollable-table"
			/>
		</div>
	);
};

export default FeedsTypeDetail;
